/** The top-level fields of a form that differ between two snapshots of its plain values. */
export function changedFields<T extends object>(current: T, since: T): Array<keyof T> {
  return (Object.keys(current) as Array<keyof T>).filter(
    (field) => JSON.stringify(current[field]) !== JSON.stringify(since[field]),
  );
}
